import React from "react";
import cn from "classnames";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDebounce } from "@uidotdev/usehooks";

import { VictimsList } from "../VictimsList";
import { PublicNav } from "../PublicNav";
import { searchParamsNames } from "../../constants/search";
import { VICTIMS_SEARCH_DEBOUNCE_MS } from "../../constants/main";
import { VictimsBrigadesList } from "../VictimsList/VictimsBrigadesList";

const buttons = [
  { labelKey: "suggest", icon: "bi bi-person-plus", path: "/application" },
  {
    labelKey: "memoryPlaque",
    icon: "bi bi-person-vcard",
    path: "/memory-plaque",
  },
];

type Props = {
  isMilitary: boolean;
  isBrigades: boolean;
};

export const VictimsPageProvider: React.FC<Props> = ({
  isMilitary,
  isBrigades,
}) => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation("main");
  const debouncedQuery = useDebounce(
    searchParams.get(searchParamsNames.query) ?? "",
    VICTIMS_SEARCH_DEBOUNCE_MS,
  );

  return (
    <div className="container">
      <PublicNav />

      <div className="row justify-content-center gx-4 mb-3">
        {buttons.map(({ labelKey, icon, path }, i) => (
          <div
            className={cn("col-8 col-sm-6 col-md-4", {
              "mb-3": i !== buttons.length - 1,
            })}
            key={labelKey}
          >
            <Link
              to={path}
              className="btn btn-secondary bg-grey btn-lg rounded-pill
                  border-white border-2 fw-medium w-100 fs-4 p-2 shadow-extra"
            >
              <span>{t(labelKey)} </span>
              <i className={icon} />
            </Link>
          </div>
        ))}
      </div>

      {isMilitary && (
        <div className="d-flex align-items-center justify-content-center mb-2">
          <div className="position-relative">
            <span className="text-white fs-5 px-3">|</span>

            <Link
              to="/"
              className="fs-5 hover-underline position-absolute start-0 top-0 text-nowrap"
              style={{
                transform: "translateX(-100%)",
                color: !isBrigades ? "white" : "#C0C0C0",
              }}
            >
              <span>Герої Дніпра</span>
            </Link>

            <Link
              to="/heroes-of-brigades"
              className="fs-5 hover-underline position-absolute end-0 top-0 text-nowrap"
              style={{
                transform: "translateX(100%)",
                color: isBrigades ? "white" : "#C0C0C0",
              }}
            >
              <span>
                Герої <span className="d-none d-md-inline">дніпровських</span>{" "}
                бригад
              </span>
            </Link>
          </div>
        </div>
      )}

      {isBrigades ? (
        <VictimsBrigadesList query={debouncedQuery} />
      ) : (
        <VictimsList query={debouncedQuery} isMilitary={isMilitary} />
      )}
    </div>
  );
};
